import { render, staticRenderFns } from "./NewMessageModal.vue?vue&type=template&id=bc8f0ea6&scoped=true"
import script from "./NewMessageModal.vue?vue&type=script&lang=js"
export * from "./NewMessageModal.vue?vue&type=script&lang=js"
import style0 from "./NewMessageModal.vue?vue&type=style&index=0&id=bc8f0ea6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8f0ea6",
  null
  
)

export default component.exports